/* globals define window document screen Image  */

define([
  'react-dom',
  'immutable',
  'lib/sumome/sumolist/formsync',
  'postscribe',
  'pixel-helpers',
  'underscore',
  'es6!sumo/util',
  'es6!launcher/util/constants',
  'es6!launcher/util/listbuilder/constants',
  'es6!launcher/util/listbuilder/embedded/util',
  'es6!launcher/util/listbuilder/wysiwyg/dom',
  'jsx!156085c5-0017-4150-b225-a731ad248f38/service/tab',
  'jsx!156085c5-0017-4150-b225-a731ad248f38/service/popupstep',
  'es6!launcher/util/listbuilder/stylebuffer/smartbar',

], (
  ReactDOM, Immutable, FormSync, postscribe, pixelHelpers, _, Util, Constants,
  ListBuilderConstants, EmbeddedUtil, WysiwygDom, Tab, PopupStep, SmartBarBuffer,
) => {
  const {
    LIST_BUILDER_3_APP_UUID: APP_ID,
  } = Constants;

  const { isValidURL, getQueryVariables, fetchSupportedImageFormats } = Util;
  const { FEATURES } = Util.Constants;
  const { FormTypes, FormGoals, TAB_FORM_TYPES, SHAKE_ANIMATION, InlineClassnames } = ListBuilderConstants;

  const addDiscountCode = (str, code) => (
    str
      .replace(/{discount}/g, code)
      .replace(/{discount_code}/g, code)
      .replace(/{prize}/g, code)
  );

  const preloadImage = (api, component) => {
    if (!component.get('mediaId') || component.get('mediaType') !== 'image') return;

    let src = Util.getMediaUrl(api, component.get('mediaId'));

    if (component.has('hash')) {
      const hash = component.get('hash');

      fetchSupportedImageFormats().then((supportedImageFormats) => {
        const convertedURL = src;
        const safeSrc = hash
          ? convertedURL
          : src;
        const img = new Image();

        img.src = safeSrc;
      });
    } else {
      const img = new Image();

      img.src = src;
    }
  };

  class ListBuilderForm {
    constructor(service, settings) {
      this.isPreview = settings.isPreview;

      this.service = service;
      this.settings = Immutable.fromJS({ ...settings });

      this.steps = {};
      this.formValues = {};
      this.formErrors = Immutable.Map();
      this.isShowing = false;

      this.id = this.settings.get('id');
      this.formType = this.settings.get('form_type');

      // Determine if the current form is for social-proof
      this.isSocialProof = this.settings.get('goal') === FormGoals.SOCIAL_PROOF;
      this.socialProofCount = 0;
      this.maxSocialProof = this.settings.get('max_popups'); // Total number of forms to display
      this.popupDisplayTime = this.settings.get('popup_display_time') * 1000 || 5000;
      this.delayBetweenPopups = this.settings.get('delay_between_popups') * 1000 || 5000;
      this.socialProofTimers = [];

      // Flag to ensure 'popup' event is logged only once
      this.hasLoggedPopup = false;

      // If it's social-proof, prepare the sequence after initial setup
      if (this.isSocialProof) {
        // Bind the sequence to the show method
        this.originalShow = this.show.bind(this);
        this.show = this.socialProofShow.bind(this);
      }

      const popupJson = this.settings.get('json');
      if (popupJson) {
        this.stepKeys = popupJson.get('steps', Immutable.List());

        popupJson.forEach((value, key) => {
          const json = value.toJS();

          if (json.components) {
            // Add ids so we have something to put in key of each component.
            WysiwygDom.addIdsToComponents(json.components);
            this.addStep(key, Immutable.fromJS(json));
          }
        });
      }

      if (this.stepKeys.contains('subscribe')) {
        this.currentStep = 'subscribe';

        this.initFormValues();
      } else if (this.stepKeys.size) {
        this.currentStep = this.stepKeys.get(0);
      }

      this.tabJson = this.settings.get('tab_json');
      if (this.tabJson && TAB_FORM_TYPES.indexOf(this.formType) > -1) {
        try {
          this.tabJson = JSON.parse(this.tabJson);
          if (this.tabJson.showType === 'before') {
            this.showTab();
          }
        } catch (e) {
          console.log('Error rendering tab:', e);
        }
      }

      // Preload any images, do not load if success step isn't used
      let components = this.settings.getIn(['json', 'subscribe', 'components'], Immutable.List());
      if (this.stepKeys.contains('success')) {
        components = components.concat(this.settings.getIn(['json', 'success', 'components'], Immutable.List()));
      }

      components.forEach(preloadImage.bind(null, this.service.api));
    }

    startSocialProofSequence() {
      const immutableEvents = this.settings.get('events');
      const events = immutableEvents ? immutableEvents.toJS() : [];

      // Get current step component settings
      const currentStep = this.getStep(this.currentStep);
      const stepComponents = currentStep.popupJsonSettings.get('components').toJS();

      // Store text templates
      const textTemplateDictionary = {};

      stepComponents.forEach(elem => {
        if (elem.type === 'text') {
          textTemplateDictionary[elem.id] = elem.text;
        }
      });

      const numEvents = Math.min(events.length, this.maxSocialProof);

      const showNextForm = () => {
        if (this.socialProofCount >= numEvents) {
          this.close(); // Close after all forms have been displayed
          return;
        }

        // iterate on components for all text elements:
        const newStepComponents = stepComponents.map((elem) => {
          const nextElem = elem;
          const currData = events[this.socialProofCount];

          nextElem.text = textTemplateDictionary[elem.id];

          if (currData && elem.type === 'text') {
            Object.keys(currData).forEach((key) => {
              nextElem.text = elem.text.replace(`{${key}}`, currData[key] || '');
            });
          }

          return nextElem;
        });

        // Show the form
        this.showStep(this.currentStep, { components: newStepComponents });
        this.socialProofCount += 1;

        // Log the 'popup' event only once
        if (!this.hasLoggedPopup) {
          this.logEvent('popup');
          this.hasLoggedPopup = true;
        }

        // Set timer to hide the form after the specified amount of seconds
        const showTimer = setTimeout(() => {
          this.hideStep(this.currentStep);

          // Set timer to show the next form after the specified amount of seconds
          const hideTimer = setTimeout(() => {
            showNextForm();
          }, this.delayBetweenPopups);

          this.socialProofTimers.push(hideTimer);
        }, this.popupDisplayTime);

        this.socialProofTimers.push(showTimer);
      };

      showNextForm();
    }

    hideStep(whichStep) {
      const step = this.getStep(whichStep);
      if (step && this.contentEl) {
        // Unmount the current step
        ReactDOM.unmountComponentAtNode(this.contentEl);
        // Optionally, add a CSS class to animate hiding
        this.contentEl.classList.add('sumome-popup-transition-down');
        // Remove the sumome-popup-transition-down class after the transition
        setTimeout(() => {
          this.contentEl.style.display = 'none';
          this.contentEl.classList.remove('sumome-popup-transition-down');
        }, 500); // Duration should match CSS transition
      }
    }

    onEnterSubmit = () => {
      if (this.currentStep === 'subscribe') {
        if (this.validateFormValues()) {
          this.submitFormValues();
        } else {
          this.renderFormErrors();
        }
      }
    };

    renderFormErrors = () => {
      const { currentStep } = this;
      const step = this.getStep(currentStep);
      const contentDomEl = this.contentEl;
      if (!step || !contentDomEl) return;

      const formValues = Immutable.Map(_.mapObject(this.formValues, (field) => field.value));
      const formErrors = this.formErrors;
      step.render(contentDomEl, formValues, formErrors);
    };

    showStep(whichStep, props) {
      const step = this.getStep(whichStep);

      if (step) {
        if (props) {
          step.popupJsonSettings = step.popupJsonSettings.merge(props);
        }

        this.currentStep = whichStep;
        const contentDomEl = this.contentEl;

        if (contentDomEl) {
          // Unmount popup step before rendering a new one. If nothing needs to be removed, nothing happens.
          ReactDOM.unmountComponentAtNode(contentDomEl);
          // Ensure the form is visible or reset any hidden styles from previous popups
          contentDomEl.style.display = 'block';
          step.render(contentDomEl);
        }
      }
    }

    getStep = id => (this.steps[id] || false);

    addStep = (id, settings) => {
      const noSumoBranding = (
        this.service.features && !_.isEmpty(this.service.features)
          ? this.hasFeature(FEATURES.NO_SUMO_BRANDING)
          : true
      );
      const nextSettings = settings.set('noSumoBranding', noSumoBranding);

      this.steps[id] = new PopupStep(this, nextSettings);
    };

    hasFeature = feature => (this.service && this.service.features[feature]);

    onClickAction = (action, component) => {
      const hasTrackingPixels = this.hasFeature(FEATURES.TRACKING_PIXELS);
      const popupJson = this.settings.get('json');
      // A failure here should close the popup to prevent page blocking
      const numSteps = popupJson.get('steps') ? popupJson.get('steps').count() : 1;
      const clickPixels = this.settings.get('pixels_click');
      const handleAction = () => {
        switch (action) {
          case 'submit':
            if (this.currentStep === 'success') {
              this.close();
              return;
            }

            if (this.validateFormValues()) {
              this.submitFormValues();
            } else {
              this.renderFormErrors();
            }

            break;

          case 'push':
            if (this.currentStep === 'success') {
              this.close();
              return;
            }

            this.requestPushApproval();
            break;

          case 'content':
          case 'redirect':
          case 'social': {
            const {
              redirectMethod,
              redirectWindow,
              redirectVariableName,
              contentUpgradeMediaId,
            } = component.props;

            let { to } = component.props;

            if (!this.discountCode) {
              const queryVars = getQueryVariables();

              if (queryVars.discount) {
                to = to.replace(/{discount}/g, queryVars.discount);
              }
            }

            // only emit click event for redirect buttons on the initial step
            if (this.currentStep === 'subscribe' && !this.isClickEmitted) {
              this.logEvent('click');
              this.isClickEmitted = true;
            }

            if (action === 'redirect' || action === 'content') {
              this.executeRedirect({
                redirectUrl: to,
                redirectVariableValue: (this.formValues.email || { value: null }).value,
                redirectMethod,
                redirectWindow,
                redirectVariableName,
                redirectMode: action,
                redirectMediaId: contentUpgradeMediaId,
              });

              this.close();
            } else if (action === 'social' && numSteps === 1) {
              this.close();
            }

            break;
          }

          case 'close':
            if (this.settings.get('form_type') === FormTypes.WELCOME_MAT) {
              this.animateClose();
            } else {
              this.close();
            }
            break;

          case 'optout':
            this.service.setOptOutCookie();
            if (this.settings.get('form_type') === FormTypes.WELCOME_MAT) {
              this.animateClose();
            } else {
              this.close();
            }
            break;

          default:
            break;
        }
      };

      if (['content', 'redirect', 'social'].indexOf(action) >= 0 && clickPixels && hasTrackingPixels) {
        this.addTrackingPixels(clickPixels, null, { id: 'click', done: handleAction });
      } else {
        handleAction();
      }
    }

    executeRedirect = (options) => {
      const {
        redirectVariableValue,
        redirectWindow,
        redirectVariableName,
        redirectMode,
        redirectMediaId,
        newWin,
      } = options;

      let {
        redirectUrl,
        redirectMethod,
      } = options;

      if (this.discountCode && redirectUrl) {
        redirectUrl = addDiscountCode(redirectUrl, this.discountCode);
      }

      const delay = 1000;

      // render content upgrade redirect URL
      if (redirectMode === 'content' && redirectMediaId) {
        const redirectMediaUrl = `https:${Util.getMediaUrl(this.service.api, redirectMediaId)}`;
        redirectUrl = redirectMediaUrl;
        redirectMethod = '';
      }

      if (redirectMethod === 'post') {
        const form = document.createElement('form');
        form.method = 'post';
        form.action = redirectUrl;

        if (redirectVariableName) {
          const field = document.createElement('input');
          field.type = 'text';
          field.name = redirectVariableName;
          field.value = redirectVariableValue;
          form.appendChild(field);
        }

        if (this.formType === FormTypes.GAME && this.winningOption && this.winningOption.get('prizeType') === 'discount') {
          const field = document.createElement('input');
          field.type = 'text';
          field.name = 'discount_campaign_id';
          field.value = this.winningOption.get('discountCampaignId');
          form.appendChild(field);
        }

        if (redirectWindow === 'new') {
          form.target = '_blank';
        }

        document.body.appendChild(form);
        setTimeout(() => form.submit(), delay);
      } else if (redirectMethod === 'get') {
        let url = redirectUrl;

        if (redirectVariableName && redirectVariableValue) {
          if (url.indexOf('?') > 0) {
            url += '&';
          } else {
            url += '?';
          }

          url += `${redirectVariableName}=${redirectVariableValue}`;
          url = encodeURI(url);
        }

        if (newWin && 'closed' in newWin && newWin.closed === false) {
          newWin.location = redirectUrl;
        } else {
          setTimeout(() => {
            if (redirectWindow === 'new') {
              window.open(url, '_blank');
              return;
            }

            window.location = url;
          }, delay);
        }
      } else {
        if (newWin && 'closed' in newWin && newWin.closed === false) {
          newWin.location = redirectUrl;
          return;
        }

        setTimeout(() => {
          if (redirectWindow === 'new') {
            window.open(redirectUrl, '_blank');
            return;
          }

          window.location = redirectUrl;
        }, delay);
      }
    };

    logEvent(event) {
      // No event logging for previews
      if (this.isPreview) return;

      // Only log 'popup' event once for social-proof
      if (this.isSocialProof && event === 'popup' && this.hasLoggedPopup) {
        return;
      }

      const { api } = this.service;

      const popupId = this.settings.get('popup_id');
      const campaignId = this.settings.get('campaign_id');
      const shortcutId = this.settings.get('shortcutId');

      // If event is 'subscribe', we don't want to log here
      // since we logSubscribeEvent server side
      if (event !== 'subscribe') {
        api.emit('event', { appId: APP_ID, event });
        api.emit('event', { appId: `${APP_ID}.${popupId}`, shortcutId, event });
        api.emit('event', { appId: `${APP_ID}.${campaignId}`, shortcutId, event });
        api.emit('event', { appId: `${APP_ID}.${popupId}.${campaignId}`, shortcutId, event });
      }
    }

    onClickTab = () => {
      if (!this.isShowing) this.show(true);
    };

    showTab = () => {
      this.tab = new Tab({
        api: this.service.api,
        onClick: this.onClickTab,
        ...this.tabJson,
      });

      this.tabEl = document.createElement('div');
      this.tabEl.className = 'sumo-form-wrapper sumome-tab-container';
      document.body.appendChild(this.tabEl);
      this.tab.render(this.tabEl);
    };

    addTrackingPixels = (pixels, vars = {}, options = {}) => {
      const popupId = this.settings.get('popup_id');
      const pixel = document.createElement('div');

      pixel.id = options.id ? (options.id + popupId) : null;

      // use id to make sure the same tracking pixels haven't been added
      if (pixel.id) {
        const existingPixels = document.getElementById(pixel.id);
        if (existingPixels) {
          // tracking pixels already added
          if (options.done && typeof options.done === 'function') options.done();
          return;
        }
      }

      pixel.style.position = 'absolute';
      pixel.style.width = '0px';
      pixel.style.height = '0px';
      pixel.style.left = '0px';
      pixel.style.right = '0px';
      pixel.style.background = 'transparent';
      pixel.style.fontSize = '0px';

      let pixelSnippet = pixelHelpers.injectVars(pixels, vars);

      if (this.discountCode) {
        pixelSnippet = addDiscountCode(pixelSnippet, this.discountCode);
      }

      document.body.appendChild(pixel);
      postscribe(pixel, pixelSnippet, options);
    };

    /**
     * Initializes the this.formValues empty set with all the valid input components of the form.
     */
    initFormValues = () => {
      const getStep = this.getStep(this.currentStep);

      let components;
      let responsiveHiddenOn = 'small';

      if (this.formType === FormTypes.WELCOME_MAT) {
        components = WysiwygDom.getDescendantComponents(getStep.getComponents(), [], {
          responsiveHiddenOn
        });
      } else {
        components = getStep.getComponents();
      }

      const initialValues = components.reduce((accum, component) => {
        const name = component.get('name');

        if (name) {
          return {
            ...accum,
            [name]: {
              name,
              value: ''
            },
          };
        }

        return accum;
      }, {});

      _.extend(this.formValues, initialValues);
    }

    onChangeForm = (formPartial) => {
      const newValues = {};

      _.each(formPartial, (value, name) => {
        newValues[name] = {
          name,
          value,
        };
      });

      _.extend(this.formValues, newValues);
    }

    onChangeSize = (height) => {
      this.popupEl.style.height = `${height}px`;
    }

    close = () => {
      // Clear all social-proof timers
      this.socialProofTimers.forEach(timer => clearTimeout(timer));
      this.socialProofTimers = [];

      // Restore the original show method if it was overridden
      if (this.isSocialProof && this.originalShow) {
        this.show = this.originalShow;
      }

      // Clear some potential timeouts
      if (this.smartBarCheckInterval) clearTimeout(this.smartBarCheckInterval);
      if (this.popupTimer) clearTimeout(this.popupTimer);

      this.removeModal();
      this.service.onClose(this.id || this.settings.get('id'));
      this.isShowing = false;

      if (this.tabJson && this.tabJson.showType === 'after' && !this.tab) {
        this.showTab();
      }

      if (this.formType === FormTypes.SMART_BAR) {
        SmartBarBuffer.removeStyleBuffer(this.settings.get('position'));
      }
    }

    applyAnimation(animation) {
      const { currentStep } = this;
      const step = this.getStep(currentStep);
      const contentDomEl = this.contentEl;
      if (this.isAnimating) return;
      if (!animation || !step || !contentDomEl) return;

      const formValues = Immutable.Map(_.mapObject(this.formValues, value => value.value));
      const { formErrors } = this;

      // Set isAnimating so we don't try to do two animations at once.
      this.isAnimating = true;

      // Clear the animation on the popup.
      // Calling render() again will only update props.
      this.currentAnimation = undefined;
      step.render(contentDomEl, formValues, formErrors);

      if (this.formType === FormTypes.WELCOME_MAT) return;

      // Wait so the dom rerenders and then apply animation.
      // This way we can apply the same animation again.  If we don't
      // clear, then nothing will happen.
      setTimeout(() => {
        this.currentAnimation = animation;
        step.render(contentDomEl, formValues, formErrors);

        // After the given animation duration, we want to set isAnimating to false.
        setTimeout(() => {
          this.isAnimating = false;
          this.currentAnimation = undefined;
        }, animation.get('duration') || 1000);
      }, 0);
    }

    submitFormValues = () => {
      if (this.isPreview) {
        const formType = this.settings.get('form_type');

        if (formType === FormTypes.WELCOME_MAT) {
          this.animateClose();
        } else {
          this.showStep('success', {
            discountCode: 'ABC-123',
            winningOption: {},
          });
        }

        return;
      }

      if (this.isFormSubmitted && !this.settings.get('triggerId')) return;

      this.isFormSubmitted = true;

      const fields = {};
      const formSyncSettings = this.settings.get('form_sync');

      _.each(this.formValues, (field, name) => {
        let value = field.value;

        if (_.isArray(value)) {
          value = _.map(value, v => v.value);
        }

        fields[name] = {
          name: field.name,
          value,
        };
      });

      let formSync;

      if (formSyncSettings) {
        let components;

        if (this.formType === FormTypes.WELCOME_MAT) {
          const flatten = (child) => {
            if (Array.isArray(child)) {
              return _.extend({}, ...child.map(item => flatten(item)));
            } else if (_.isObject(child)) {
              return _.extend({}, ...Object.keys(child).map(key => flatten(child[key])), (child.name && (child.formsync_field || child.form_sync_field)) ? { [child.name]: child.formsync_field || child.form_sync_field } : {});
            }

            return {};
          };

          components = flatten(this.settings.get('json').toJS());
        } else {
          components = this.settings.get('json').map((step) => {
            return step.get('components');
          }).toList().flatten(true).filter((c) => {
            return (c !== undefined && c.get('name') !== undefined && ((c.get('formsync_field') !== undefined && c.get('formsync_field') !== '') || (c.get('form_sync_field') !== undefined && c.get('form_sync_field') !== '')));
          }).groupBy((c) => {
            return c.get('name');
          }).map((c) => {
            return c.get(0).get('formsync_field') || c.get(0).get('form_sync_field');
          }).toJS();
        }

        formSync = new FormSync(formSyncSettings.toJS(), components);
        formSync.install(fields);
      }

      const listId = this.settings.get('list_id');
      const popupId = this.settings.get('popup_id');
      const campaignId = this.settings.get('campaign_id');
      const discountCampaignId = (this.formType === FormTypes.GAME)
        ? this.winningOption.get('discountCampaignId') : this.settings.get('discount_campaign_id');

      const data = {
        site_id: this.service.api.properties.siteId,
        visitor_id: this.service.api.properties.visitorId,
        app_id: APP_ID,
        popup_id: popupId,
        object_id: `${popupId},${campaignId}`,
        sumolist_id: campaignId,
        href: window.location.href || null,
        ref: document.referrer || null,
        fields: JSON.stringify(fields),
        discount_campaign_id: discountCampaignId,
        list_id: listId,
      };

      let email = fields.email;
      if (email && !_.isString(email)) {
        email = email.value;
      }

      let pushId = fields.push_id;
      if (pushId && !_.isString(pushId)) {
        pushId = pushId.value;
      }

      let newWin;
      if (this.settings.get('subscribe_redirect_url') && isValidURL(this.settings.get('subscribe_redirect_url')) && this.settings.get('subscribe_redirect_target') === 'new') {
        newWin = window.open('', '_blank');
      }

      if (this.winningOption) {
        if (this.winningOption.get('prizeType') === 'content') {
          const redirectMediaUrl = `https:${Util.getMediaUrl(this.service.api, this.winningOption.get('contentMediaId'))}`;
          data.prize = `[Download](${redirectMediaUrl})`;
        }

        data.prize_text = this.winningOption.get('label');
      }

      this.service.post('/list/subscribe', data, {
        withCredentials: false,
        headers: {
          'X-Sumo-Auth': this.service.getCookie('__smToken'),
        },
      }).then(res => this.onSubmit(res, email, pushId, formSync, newWin));
    };

    onSubmit(res, email, pushId, formSync, newWin) {
      const {
        success,
        err,
        discountCode,
      } = res.data;

      if (success) {
        this.discountCode = discountCode || null;
        this.completeSubscribe(email, pushId, newWin);
        if (formSync) {
          if (discountCode) {
            Object.keys(formSync.fields).forEach((field) => {
              const value = formSync.fields[field].value;

              if (value) {
                formSync.fields[field].value = value
                  .replace(/{discount_code}/g, discountCode)
                  .replace(/{discount}/g, discountCode);
              }
            });
          }

          formSync.submit();
        }
      } else {
        if (err) {
          const newFormErrors = this.formErrors.toJS();
          newFormErrors.email = err;
          this.formErrors = Immutable.fromJS(newFormErrors);
        }

        if (newWin && 'close' in newWin) {
          newWin.close();
        }

        this.isFormSubmitted = false;
        this.renderFormErrors();
      }
    }

    completeSubscribe(email, pushId, newWin) {
      const hasTrackingPixels = this.hasFeature(FEATURES.TRACKING_PIXELS);
      const conversionPixels = this.settings.get('pixels_conversion');

      if (email && this.service.conversions.indexOf(email) === -1) {
        this.service.conversions.push(email);
        this.logEvent('subscribe');
      }

      if (pushId && this.service.conversions.indexOf(pushId) === -1) {
        this.service.conversions.push(pushId);
        this.logEvent('subscribe-push');
      }

      if (email) this.service.setSubscribedCookie();

      if (pushId) {
        this.service.setPushSubscribedCookie();
        if (this.pushRequestWindow) this.pushRequestWindow.close();
      }

      if (this.tab) {
        this.tabEl.parentNode.removeChild(this.tabEl);
        this.tab = null;
        this.tabJson = null;
      }

      let redirectVariableValue = null;
      if (email) redirectVariableValue = email;
      else if (pushId) redirectVariableValue = pushId;

      if (hasTrackingPixels && conversionPixels) {
        const conversionValues = (email || pushId) ? {} : null;
        if (email) conversionValues['subscriber-email'] = email;
        if (pushId) conversionValues['subscriber-push'] = pushId;
        this.addTrackingPixels(conversionPixels, conversionValues, { id: 'conversion', done: () => this.postSubscribe(redirectVariableValue, newWin) });
      } else {
        this.postSubscribe(redirectVariableValue, newWin);
      }
    }

    postSubscribe(redirectVariableValue, newWin) {
      const isURLRedirect = (this.settings.get('subscribe_redirect_mode') === 'url' && this.settings.get('subscribe_redirect_url') && isValidURL(this.settings.get('subscribe_redirect_url')));
      const isContentUpgradeRedirect = (this.settings.get('subscribe_redirect_mode') === 'content' && this.settings.get('subscribe_redirect_media_id'));
      const formType = this.settings.get('form_type');
      const closeTimer = this.settings.get('popup_timer');

      if (formType === FormTypes.GAME && !this.hasShownAnimation) {
        this.showGameResults(() => {
          this.hasShownAnimation = true;
          this.postSubscribe(redirectVariableValue, newWin);
        });

        return;
      }

      if (closeTimer === -999 && !(isURLRedirect || isContentUpgradeRedirect)) { // Do not show success
        this.close();
        return;
      }
      if (isURLRedirect || isContentUpgradeRedirect) {
        this.executeRedirect({
          redirectUrl: this.settings.get('subscribe_redirect_url'),
          redirectVariableValue,
          redirectMethod: this.settings.get('subscribe_redirect_method'),
          redirectWindow: this.settings.get('subscribe_redirect_target'),
          redirectVariableName: this.settings.get('subscribe_redirect_variable'),
          redirectMode: this.settings.get('subscribe_redirect_mode'),
          redirectMediaId: this.settings.get('subscribe_redirect_media_id'),
          newWin,
        });

        if (this.settings.get('subscribe_redirect_target') === 'new' || isContentUpgradeRedirect) {
          if (formType === FormTypes.WELCOME_MAT) {
            this.animateClose();
          } else {
            this.showStep('success', {
              discountCode: this.discountCode,
              winningOption: this.winningOption,
            });
          }
        }

        if (closeTimer === -999) { // Close popup immediately after redirect
          this.close();
          return;
        }
      } else {
        // Remove the overlay dark class and change the blackout status after subscribe to ensure
        // that success popup does not continue trigger of blackout overlay
        if (formType === FormTypes.INLINE_POPUP) {
          this.embedBlackoutStatus = 'light';
          if (this.activeInlinePopupEl) {
            this.toggleEmbeddedBlackoutClass(
              this.activeInlinePopupEl.overlayEl,
              InlineClassnames.DARK,
              InlineClassnames.LIGHT,
            );
          }
        }

        if (formType === FormTypes.WELCOME_MAT) {
          this.animateClose();
        } else {
          this.showStep('success', {
            discountCode: this.discountCode,
            winningOption: this.winningOption,
          });
        }
      }
      if (closeTimer > 0) {
        this.popupTimer = setTimeout(() => { this.close(); }, closeTimer * 1000);
      }
    }

    validateFormValues() {
      // Remove existing error messages
      const newFormErrors = {};
      const { formValues } = this;
      const getStep = this.getStep(this.currentStep);

      let responsiveHiddenOn = 'small';
      if (this.responsiveFormat === 'default') responsiveHiddenOn = 'medium';

      let step;
      if (this.formType === FormTypes.WELCOME_MAT) {
        step = WysiwygDom.getDescendantComponents(getStep.getComponents(), [], {
          responsiveHiddenOn,
        });
      } else {
        step = getStep.getComponents();
      }

      const invalidComponents = step.filter((component) => {
        const name = component.get('name');
        const type = component.get('type');
        const required = component.get('required') || (name === 'email' && type === 'textField') || false;
        const emailAddressPattern = /\S+@\S+\.\S/;
        let errorMessage;

        if (required) {
          if (!formValues.hasOwnProperty(name)) errorMessage = 'This field is required.';
          // TODO: check type??
          else if (!formValues[name].hasOwnProperty('value')) errorMessage = 'This field is required.';
          else if (!formValues[name].value) errorMessage = 'This field is required';
          else if (name === 'email' && !emailAddressPattern.test(formValues[name].value)) {
            errorMessage = 'Invalid email address.';
          }
        }

        // TODO: More verbose error messages
        if (name) {
          newFormErrors[name] = errorMessage;
        }

        return !!errorMessage;
      });

      if (!Immutable.is(this.formErrors, newFormErrors)) {
        this.formErrors = Immutable.fromJS(newFormErrors);
      }

      return (this.formType === FormTypes.WELCOME_MAT) ?
        invalidComponents.length === 0 : invalidComponents.count() === 0;
    }

    socialProofShow(triggerExists, ignoreYield) {
      // Call the original show method to display the popup
      this.originalShow(triggerExists, ignoreYield);

      // Start the social-proof sequence
      this.startSocialProofSequence();
    }

    show(triggerExists, ignoreYield) {
      const hasTrackingPixels = this.hasFeature(FEATURES.TRACKING_PIXELS);
      const popupId = this.settings.get('popup_id');
      const trackingPixels = this.settings.get('pixels_shown');
      const shouldYield = this.settings.get('yield');

      // Check if a list builder popup is already showing
      const existingPopupEl = document.querySelector('.s.u.m.o.me.listbuilder-popup:not(.listbuilder-popup-embedded)');
      if (existingPopupEl) return;

      if (
        shouldYield
        && this.service.api.properties.yield
        && this.formType !== FormTypes.INLINE_POPUP
        && !triggerExists
        && !ignoreYield
      ) {
        console.log(`${this.formType} is yielding...`);
        return;
      }

      this.isShowing = true;

      // Set shown cookie
      if (!this.isPreview) {
        setTimeout(() => this.service.setShownCookie(this), 0);
      }

      if (this.formType === FormTypes.INLINE_POPUP) {
        this.anchorEl = this.settings.get('anchorEl') || EmbeddedUtil.findEmbeddedAnchor(this.settings.get('auto_embed_placement'));
        if (!this.anchorEl) return;
      } else if (!triggerExists) {
        this.service.api.emit('setProperties', { yield: true });
      }

      if (this.service.shownPopups.indexOf(popupId) === -1 || this.formType !== FormTypes.INLINE_POPUP) {
        this.logEvent('popup');
        this.service.shownPopups.push(popupId);
      }

      if (this.formType === FormTypes.INLINE_POPUP && !triggerExists) {
        this.installEmbedded();
      } else {
        this.installModal();
      }

      if (hasTrackingPixels && trackingPixels) {
        this.addTrackingPixels(trackingPixels, null, { id: 'tracking' });
      }
    }

    createInnerContainer(containerRefName, parentRefName, classes = '') {
      this[containerRefName] = document.createElement('div');
      this[containerRefName].className = classes;
      this[parentRefName].appendChild(this[containerRefName]);
    }

    installModal() {
      const size = this.settings.get('content_width');
      const isCustom = this.settings.get('goal') === 'custom';
      const isAdvancedForm = isCustom && this.settings.get('advanced_form');

      const swipeTime = 150;
      let startTime;

      // container
      this.popupEl = document.createElement('div');

      if (!this.isSocialProof) {
        this.popupEl.className = 'sumo-form-wrapper listbuilder-popup';

        // modal mask
        this.createInnerContainer('modalMaskEl', 'popupEl', 'listbuilder-popup-overlay');

        // content
        this.createInnerContainer('contentEl', 'popupEl', 'listbuilder-popup-content');
      } else {
        this.popupEl.className = 'sumo-form-wrapper scrollbox-popup bdow-social-proof-form';

        // content
        this.createInnerContainer('contentEl', 'popupEl', 'scrollbox-popup-content');
      }

      if (isAdvancedForm) {
        // Add all the legacy classes
        const popupEl = document.createElement('div');
        popupEl.className = 'sumome-advanced-listbuilder-popup';

        this.popupEl.className = `sumome-vex sumome-popup sumome-popup-mode-subscribe sumome-popup-${size}`;
        this.modalMaskEl.className = 'sumome-popup-overlay';
        this.contentEl.className = 'sumome-vex-content sumome-popup-content sumome-popup-content-default sumome-popup-content-advanced';

        popupEl.appendChild(this.popupEl);
        this.popupEl = popupEl;
      }

      document.body.appendChild(this.popupEl);

      // Add the class to the body to prevent scrolling for normal popups
      if (!this.isSocialProof) {
        // It seems the setTimeout with a delay of 0 effectively defers the execution of
        // the code until after the current call stack is cleared
        setTimeout(() => {
          document.documentElement.className += ' listbuilder-popup-open';
        }, 0);
      }

      // Dismiss overlay on mobile devices only
      document.addEventListener('touchstart', (event) => {
        startTime = new Date();
        this.overlayTouchTarget = event.target.getAttribute('class') && event.target.getAttribute('class').indexOf(this.contentEl.className) >= 0;
      }, false);

      document.addEventListener('touchend', (event) => {
        const endTime = new Date();
        const endOverlayTouchTarget = event.target.getAttribute('class') && event.target.getAttribute('class').indexOf(this.contentEl.className) >= 0;
        if (endOverlayTouchTarget && this.overlayTouchTarget && endTime - startTime < swipeTime) {
          event.stopPropagation();
          event.preventDefault();
          this.overlayTouchTarget = false;
          this.close();
        }
      }, false);

      // showStep will render the animation so no need to call applyAnimation.
      // We just need to set the currentAnimation.
      const animation = this.settings.get('animation');
      if (animation) this.currentAnimation = animation;

      this.showStep(this.currentStep);
    }

    removeModal = () => {
      // Grab the blackout overlay div for removal
      const duration = 600;

      if (this.formType === FormTypes.INLINE_POPUP) {
        // Fade the active popup overlay background back to transparent if inline popup is active
        if (this.activeInlinePopupEl) {
          this.toggleEmbeddedBlackoutClass(
            this.activeInlinePopupEl.overlayEl,
            InlineClassnames.DARK,
            InlineClassnames.LIGHT,
          );
        }
        this.popupEl.style.maxHeight = `${this.popupEl.offsetHeight}px`;
        this.popupEl.style.transform = 'translateX(-200%)';
        setTimeout(() => {
          this.popupEl.style.maxHeight = '0';
          setTimeout(() => {
            // Remove the overlay blackout element, then the popup
            this.popupEl.parentElement.removeChild(this.blackoutOverlayEl);
            this.popupEl.parentElement.removeChild(this.popupEl);
          }, duration / 2);
        }, duration / 2);
      } else {
        if (this.popupEl && this.popupEl.parentElement) {
          this.popupEl.parentElement.removeChild(this.popupEl);
        }

        this.popupEl = null;
      }
    }

    openCenteredWindow(url, title, w, h) {
      // opens popup window centered within viewport and returns context
      const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
      const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

      let width;
      let height;

      if (window.innerWidth) {
        width = window.innerWidth;
      } else if (document.documentElement.clientWidth) {
        width = document.documentElement.clientWidth;
      } else {
        width = screen.width;
      }

      if (window.innerHeight) {
        height = window.innerHeight;
      } else if (document.documentElement.clientHeight) {
        height = document.documentElement.clientHeight;
      } else {
        height = screen.height;
      }

      const left = ((width / 2) - (w / 2)) + dualScreenLeft;
      const top = ((height / 2) - (h / 2)) + dualScreenTop;
      const newWindow = window.open(url, title, `scrollbars=yes, width=${w}, height=${h}, top=${top}, left=${left}`);

      if (window.focus) {
        newWindow.focus();
      }
      return newWindow;
    }

    receivePushApprovalResponse = (event) => {
      const pushResponse = event.data || null;
      if (pushResponse && pushResponse.push_sumo) {
        if (pushResponse.subscription_status === 'subscribed') {
          this.formValues.push_id = { name: 'push_id', value: pushResponse.subscriber_id };
          this.submitFormValues();
        } else {
          this.applyAnimation(SHAKE_ANIMATION);
        }
      }
    }

    requestPushApproval() {
      const subdomainName = this.settings.get('push_subdomain_name');
      const vid = this.service.api.properties.visitorId;
      const ref = encodeURIComponent(document.referrer);

      window.removeEventListener('message', this.receivePushApprovalResponse, false);
      window.addEventListener('message', this.receivePushApprovalResponse, false);
      this.pushRequestWindow = this.openCenteredWindow(
        `https://${subdomainName}.push.sumome.com/?vid=${vid}&ref=${ref}`,
        'pushSumoWindow',
        620,
        480,
      );
    }
  }

  return ListBuilderForm;
});